import React from "react";

import GraphqlWrapper from "GraphQL/GraphqlWrapper";

import Table from "./Table";

const DebtorsApp = props => {
  return (
    <GraphqlWrapper>
      <section className="debtor_section">
        <Table />
      </section>
    </GraphqlWrapper>
  );
};

export default DebtorsApp;
